import Checkbox from "components/checkbox";
import Dropdown from "components/dropdown";
import InputField from "components/fields/InputField";
import { FaAngleDown } from "react-icons/fa6";

const Settings = () => {
    return (
      <div className="mt-12 mb-10 relative px-2.5 md:px-3 lg:px-5 text-center">
        <h1 className="text-header mb-2 !text-center">Feedback Form</h1>
        <p className="text-medium mb-4">Get in touch with us for any inquiries or assistance.</p>
        <div className="px-5 md:px-[80px] py-6 max-w-[680px] mx-auto box overflow-hidden bg-white dark:bg-darkPrimary flex-col items-center text-left">
          {/* Email */}
          <InputField
            variant="auth"
            extra="mb-6 md:min-w-[350px]"
            label="Full Name"
            placeholder="Full name"
            id="name"
            type="text"
          />

          {/* Password */}
          <InputField
            variant="auth"
            extra="mb-6 md:min-w-[350px]"
            label="Email Address"
            placeholder="Email"
            id="email"
            type="text"
          />

          <Dropdown
            extra="grow"
            button={
              <div className="relative w-full">
                <InputField
                  variant="auth"
                  extra="mb-6 md:min-w-[350px]"
                  label="Subject"
                  placeholder="Please select Your Message Subject"
                  id="subject"
                  type="text"
                />
                <span className="text-large text-gray-300 absolute top-[25px] right-3"><FaAngleDown /></span>
              </div>
            }
            animation="origin-[50%_0%] md:origin-top-center transition-all duration-300 ease-in-out"
            children={
              <div className="box rounded-[7px] py-2.5 bg-white dark:bg-darkGrey1 grid grid-cols-1">
                <div className="text-xsmall mb-2.5 px-[14px] py-1 border-b-[1px] border-gray-100 dark:border-lightGrey hover:bg-gray-50 hover:dark:bg-darkGrey" >
                  <p className="dark:text-white">Pending Transaction Inquiry</p>
                  <p className="text-gray-700 dark:text-gray-300">For questions or concerns about transactions that are unconfirmed or stuck on the network.</p>
                </div>
                <div className="text-xsmall mb-2.5 px-[14px] py-1 border-b-[1px] border-gray-100 dark:border-lightGrey hover:bg-gray-50 hover:dark:bg-darkGrey" >
                  <p className="dark:text-white">Technical Issue</p>
                  <p className="text-gray-700 dark:text-gray-300">Report any problems with the functionality, performance, or usability of the BBAScan platform.</p>
                </div>
                <div className="text-xsmall mb-2.5 px-[14px] py-1 border-b-[1px] border-gray-100 dark:border-lightGrey hover:bg-gray-50 hover:dark:bg-darkGrey" >
                  <p className="dark:text-white">General Feedback</p>
                  <p className="text-gray-700 dark:text-gray-300">Share your thoughts, suggestions, or comments to help us improve our block explorer services.</p>
                </div>
                <div className="text-xsmall mb-2.5 px-[14px] py-1 border-b-[1px] border-gray-100 dark:border-lightGrey hover:bg-gray-50 hover:dark:bg-darkGrey" >
                  <p className="dark:text-white">Feature Request</p>
                  <p className="text-gray-700 dark:text-gray-300">Suggest new features or tools you’d like to see added to enhance your experience.</p>
                </div>
              </div>
            }
            classNames={"w-full mt-11"}
          />
          
          <div className="mb-6 md:min-w-[350px]">
            <label className="text-small text-gray-800 dark:text-gray-300 ml-1.5 font-medium">Message</label>
            <textarea 
              placeholder="Message"
              rows={6}
              className={`mt-1 flex w-full items-center justify-center rounded-[6px] border bg-white dark:bg-gray-900 pl-3 py-1 pr-10 text-sm outline-none border-gray-200 dark:!border-white/10 dark:text-white`}></textarea>
          </div>

          <div className="flex items-center mb-6">
            <Checkbox extra="mr-2"/>
            <span className="text-xsmall text-gray-700"> I have read the guidelines and understand the scope of assistance provided by BBAScan.</span>
          </div>
          
          <button className="linear w-full btn">
            Submit Feedback
          </button>
        </div>
      </div>
    );
}

export default Settings;